import axios from 'axios';

// axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
    // if xdebug get param is present, add it to the request url
    const xdebugMatch = window.location.href.match(/(XDEBUG_SESSION_START=\d+)/);
    if(xdebugMatch) {
        config.url = config.url.indexOf('?') > -1 ? `${config.url}&${xdebugMatch[1]}` : `${config.url}?${xdebugMatch[1]}`;
    }

    return config;
});

export default axios;

//
// export function addCsrfTokenInterceptor(token) {
//     axios.interceptors.request.use(function (config) {
//         config.withCredentials = true;
//     });
// }
